import { Down, Shield } from "../icons";
import { Credentials } from "../layout";
import { Covers } from "./covers";

const INCOMING = [
  ["A. Receiving practice", "WarmNest Counselling details, registration and services offered."],
  ["B. Referring professional", "Your name, profession, organisation, contact details and registration number."],
  ["C. Client information", "Client name, pronouns, date of birth, contact details, language and emergency contact — completed with the client's knowledge and consent."],
  ["D. Reason for referral", "Primary areas of concern: stress and anxiety, grief and loss, trauma, relationships, couples, women's wellness, burnout, HIV/TB psychosocial support, and more."],
  ["E. Urgency & risk", "Routine, urgent or emergency, plus any current risk indicators and safety notes."],
  ["F. Previous or current support", "Prior counselling, psychiatric treatment, medication, social work or substance-abuse support."],
  ["G. Session & contact preferences", "Session type requested, preferred days and times, sliding scale and funding source."],
  ["H. Declaration", "Signed confirmation that the information is accurate and consent has been obtained."],
];

export function Incoming() {
  return (
    <section className="wrap-m section">
      <span className="kicker">Form WC-REF-IN-01</span>
      <h1 className="center">Incoming Client Referral</h1>
      <p className="center soft" style={{ maxWidth: 640, margin: "0 auto 2rem" }}>
        Referring a client <strong>to</strong> WarmNest Counselling. Please complete the form as fully as possible and submit it to <a className="link" href="mailto:warmnestcounselling@gmail.com">warmnestcounselling@gmail.com</a> or WhatsApp <a className="link" href="tel:+27814727220">081 472 7220</a>. All information is treated as strictly confidential in accordance with POPIA (Act 4 of 2013).
      </p>
      <p className="center"><a className="btn btn-dark" href="/wwc-incoming-referral-form.pdf" download><Down /> Download Incoming Referral Form (PDF)</a></p>
      <h2>What the form covers</h2>
      <Covers items={INCOMING} />
      <div className="callout peach">
        <Shield />
        <div>
          <p><strong>If the client is in immediate danger</strong></p>
          <p>Contact emergency services on <a className="link" href="tel:10111">10111</a> or <a className="link" href="tel:112">112</a>, or the SADAG Suicide Crisis Line on <a className="link" href="tel:0800567567">0800 567 567</a>, before submitting this referral.</p>
        </div>
      </div>
      <div style={{ marginTop: "3rem" }}><Credentials /></div>
    </section>
  );
}
